/**
 * Configuration des champs pour chaque type d'événement Twitch CLI
 * @module admin/constants/eventFieldsConfig
 */

/**
 * Configuration des champs pour chaque type d'événement EventSub
 * @type {Object.<string, Array>}
 */
export const eventFieldsConfig = {
  'channel.follow': [
    {
      name: 'user_id',
      label: 'ID Follower',
      type: 'text',
      placeholder: 'ID du viewer qui follow',
    },
    {
      name: 'user_login',
      label: 'Login Follower',
      type: 'text',
      placeholder: 'Login du viewer (ex: testuser)',
    },
    {
      name: 'user_name',
      label: 'Nom Follower',
      type: 'text',
      placeholder: 'Nom affiché du viewer',
    },
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster suivi',
    },
  ],
  'channel.subscribe': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
    {
      name: 'user_name',
      label: "Nom d'utilisateur",
      type: 'text',
      placeholder: 'Nom du viewer qui sub',
    },
    {
      name: 'tier',
      label: 'Tier',
      type: 'select',
      options: ['1000', '2000', '3000'],
    },
    { name: 'is_gift', label: 'Est un cadeau', type: 'checkbox' },
  ],
  'channel.subscription.gift': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
    {
      name: 'user_name',
      label: 'Nom du donateur',
      type: 'text',
      placeholder: 'Nom du viewer qui offre les subs',
    },
    {
      name: 'total',
      label: 'Nombre de subs offerts',
      type: 'number',
      min: 1,
      max: 100,
    },
    {
      name: 'tier',
      label: 'Tier',
      type: 'select',
      options: ['1000', '2000', '3000'],
    },
    { name: 'is_anonymous', label: 'Anonyme', type: 'checkbox' },
  ],
  'channel.cheer': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
    {
      name: 'user_name',
      label: "Nom d'utilisateur",
      type: 'text',
      placeholder: 'Nom du viewer qui donne les bits',
    },
    { name: 'bits', label: 'Nombre de bits', type: 'number', min: 1 },
    {
      name: 'message',
      label: 'Message',
      type: 'text',
      placeholder: 'Titre de la musique (pour 25 bits) ou vide',
    },
    { name: 'is_anonymous', label: 'Anonyme', type: 'checkbox' },
  ],
  'channel.raid': [
    {
      name: 'from_broadcaster_user_id',
      label: 'ID Raider',
      type: 'text',
      placeholder: 'ID du broadcaster qui raid',
    },
    {
      name: 'from_broadcaster_user_login',
      label: 'Login Raider',
      type: 'text',
      placeholder: 'Login du broadcaster qui raid (ex: mon_pseudo)',
    },
    {
      name: 'from_broadcaster_user_name',
      label: 'Nom Raider',
      type: 'text',
      placeholder: 'Nom affiché du broadcaster qui raid',
    },
    {
      name: 'to_broadcaster_user_id',
      label: 'ID Cible',
      type: 'text',
      placeholder: 'ID du broadcaster cible',
    },
    { name: 'viewers', label: 'Nombre de viewers', type: 'number', min: 1 },
  ],
  'stream.online': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
  ],
  'stream.offline': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
  ],
  'channel.subscription.message': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
    {
      name: 'user_name',
      label: "Nom d'utilisateur",
      type: 'text',
      placeholder: 'Nom du viewer qui resub',
    },
    {
      name: 'tier',
      label: 'Tier',
      type: 'select',
      options: ['1000', '2000', '3000'],
    },
    {
      name: 'message_text',
      label: 'Message de resub',
      type: 'text',
      placeholder: 'Message du viewer',
    },
    {
      name: 'cumulative_months',
      label: 'Mois cumulés',
      type: 'number',
      min: 1,
      placeholder: 'Nombre de mois total',
    },
    {
      name: 'streak_months',
      label: 'Mois consécutifs',
      type: 'number',
      min: 0,
      placeholder: 'Nombre de mois consécutifs',
    },
  ],
  'channel.channel_points_custom_reward_redemption.add': [
    {
      name: 'broadcaster_user_id',
      label: 'ID Broadcaster',
      type: 'text',
      placeholder: 'ID du broadcaster',
    },
    {
      name: 'reward_id',
      label: 'ID Récompense',
      type: 'text',
      placeholder: 'ID de la récompense',
    },
    {
      name: 'reward_type',
      label: 'Type de récompense',
      type: 'select',
      options: ['normal', 'random', 'skip'],
      optionLabels: {
        normal: 'Mettre une musique',
        random: 'Musique aléatoire',
        skip: 'Skip musique',
      },
    },
    {
      name: 'reward_title',
      label: 'Titre Récompense',
      type: 'text',
      placeholder: 'Titre de la récompense (doit contenir "musique")',
    },
    {
      name: 'user_input',
      label: 'Message utilisateur',
      type: 'text',
      placeholder: 'Titre de la musique à ajouter',
    },
  ],
};
